import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgCardTypeAudio = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M8 7h15" }),
			/* @__PURE__ */ _jsx("path", {
				d: "M23 17.5V1H8v18.5",
				"data-cap": "butt"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 4.5,
				cy: 19.5,
				r: 3.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 19.5,
				cy: 17.5,
				r: 3.5
			})
		]
	})
});
export default SvgKgCardTypeAudio;
